const formatDateYear = (inputDate) => {
    if (inputDate === null || inputDate === undefined || inputDate === '') return '';

    const date = new Date(inputDate);

    if (Number.isNaN(date.getTime())) return '';

    const monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
    const dayOfMonth = date.getDate();
    const daySuffix = ["th", "st", "nd", "rd"][
        dayOfMonth % 10 === 1 &&
        dayOfMonth !== 11 ? 1 :
        dayOfMonth % 10 === 2 &&
        dayOfMonth !== 12 ? 2 :
        dayOfMonth % 10 === 3 &&
        dayOfMonth !== 13 ? 3 : 0
    ];
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const outputDate = `${monthName} ${dayOfMonth}${daySuffix}, ${year}`;

    return outputDate;
};

export default formatDateYear;
